<template>
  <div
    class="modal fade"
    :id="`delete-modal-${categoryKey}-${sectionIndex}`"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    :aria-labelledby="`form-modal-${categoryKey}-${sectionIndex}-label`"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" :id="`form-modal-${categoryKey}-${sectionIndex}-label`">Eliminare elemento da {{ sectionTitle }}?</h5>
          <button type="button" class="btn btn-xs btn-icon btn-ghost-secondary" data-dismiss="modal" aria-label="Close">
            <i class="tio-clear tio-lg"></i>
          </button>
        </div>
        <!-- <div class="modal-body"></div> -->
        <div class="modal-footer">
          <button type="button" class="btn btn-white" data-dismiss="modal">Annulla</button>
          <button type="button" class="btn btn-danger" @click="submit">Elimina</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["categoryKey", "sectionIndex", "sectionTitle"],

  methods: {
    submit() {
      this.$emit("submit");
    },
  },
};
</script>

<style>
</style>